<template>
  <div class="admin-devices">
    
    <div class="panelheader border-2">
      <div class="title">{{pageName}}</div>
      <div class="new-device-btn">
       <el-button type="add" v-on:click="openNewDeviceForm()">Add Device</el-button>
      </div>
    </div>
    <div v-if="!dialogVisible">
      <div class="devices">
        <div v-if="loading"><icon name="circle-o-notch" scale="1.5" spin class="loading-icon"></icon></div>
          <vuetable
              ref="vuetable"
              api-url="/api/super/devices"
              :http-options="header"
              :fields="columns"
              detail-row-component="relay-table"
              @vuetable:cell-clicked="onCellClicked"
              @vuetable:loaded="onLoaded"
              v-bind:class="{noShow: loading}"
              pagination-path=''>

             <template slot="actions" slot-scope="props">
              <div class="custom-actions">

                <button class="ui icon button edit-btn"
                  @click="updateDevice(props.rowData.id)">
                  <i class="edit icon"></i>
                </button>
                <button class="ui icon button del-btn"
                  @click="deleteDevice(props.rowData.id)">
                  <i class="delete icon"></i>
                </button>
                <!-- <el-popover
                  ref="popover1"
                  placement="top-start"
                  trigger="hover"
                  content="Displays green if online">
                </el-popover> -->
                <el-popover
                  ref="pingpopover"
                  placement="right"
                  trigger="hover"
                  :content="'Ping: ' + props.rowData.ping"
                  :disabled="!pingPop">
                </el-popover>
                <div
                  v-popover:pingpopover
                  class="ui icon button test-btn"
                  v-bind:class="{online: props.rowData.online}"
                  @click="testDevice(props.rowData)"
                  data-content="Is online">
                  <i class="idea icon"></i>
                </div>
              </div>
            </template>
          </vuetable>

      </div>
    </div>
    <new-device :display="dialogVisible" v-on:closeForm="closeForm" :update="updating" :device_id="device_id"></new-device>
  </div>
</template>

<script>
  import requests from '../../../requests';
  import NewDevice from './NewDevice.vue';
  import RelayTable from './RelayTable.vue';
  import auth from '../../../auth';
  import 'vue-awesome/icons/circle-o-notch'
  import Icon from 'vue-awesome/components/Icon'
  //Vue.component('relay-table', RelayTable)
  export default {
    name: 'admin-devices',
    data() {
      return {
        isOnline: true,
        pageName: 'Device Management',
        devices: [],
        dialogVisible: false,
        device_id: '',
        updating: false,
        header: {},
        loading: true,
        columns: [
          {name: 'id', title: 'ID', titleClass: 'hidden', dataClass: 'hidden'},
          {name: 'name', title: 'Name'},
          {name: 'ip', title: 'IP'},
          {name: 'port', title: 'Port'},
          {name: 'site', title: 'Site'},
          {name: 'serial', title: 'Serial Number'},
          {name: '__slot:actions',titleClass: 'center aligned sm-col', dataClass: 'center aligned sm-col'},
        ],
        popoverContent: '',
        pingPop: false,
      }
    },
    beforeMount() {
      //this.getDevices();
      var header = {headers: auth.getAuthHeader()};
      this.header = {headers:{'x-access-token':header['headers']['x-access-token']}};
    },
    methods: {
      openNewDeviceForm() {
        this.updating = false;
        this.device_id = '';
        this.dialogVisible = true;
      },
      closeForm(){
        this.dialogVisible = false;
        this.updating = false;
        this.device_id = '';
        this.getDevices();
      },
      updateDevice(device_id){
        this.device_id = device_id;
        this.updating = true;
        this.dialogVisible = true;
      },
      deleteDevice(device_id){
         var context = this;
         requests.deleteDevice(this, device_id, function(result){
           console.log(result.action);
            if(result.action == "success"){
              context.$message({
                showClose: true,
                type: 'success',
                message: 'Successfully deleted device'
              });
              context.getDevices();
            } else {
              context.$message({
                showClose: true,
                type: 'error',
                message: 'Error deleting device'
              });
            }
            context.getDevices();
            context.$refs.vuetable.refresh();
         });
      },
      getDevices(){
        var context = this;
        requests.getDevices(this, function(result){
          context.devices = result.data;
          console.log(JSON.parse(JSON.stringify(result.data)));
        });
      },
      onCellClicked(data, field, event){
        if(data.type_id === 1) {
          this.$refs.vuetable.toggleDetailRow(data.id);
        }
      },
      testDevice(row) {
        this.getDevices();
      },
      onLoaded() {
        this.loading = false;
        var context = this;

        $('.test-btn').on('mouseover', (event) => {
          if(event.currentTarget.classList.contains("online")){
            context.pingPop = true;
          } else {
            context.pingPop = false;
          }
        });

        $('.test-btn').on('mouseleave', () => {
            context.pingPop = false;
        });
      }
    },
    components: {
      'new-device':NewDevice,
      'relay-table':RelayTable,
      Icon
    }
  }

</script>

<style>

  .port-title {
    margin-top: 18pt;
    margin-bottom: 8pt;
    font-size: 1.4em;
  }
  
  .devices, .new-device {
    display: block;
    padding: 15pt;
    background-color: white;
  }
  
  .new-device-btn {
    margin-top: 4pt;
    float: right;
    width: 20%;
    text-align: right;
    margin-right: 10pt;
  }
  
  .deviceLabel {
    text-align: left;
    font-weight: 400;
    font-size: 1.6em;
    padding-bottom: 10pt;
    margin-top: 8pt;
    margin-bottom: 6pt;
    color: #656565;
  }
  
  .r-head {
    background-color: #EEF1F6;
    font-size: 1.2em;
    font-weight: 600;
  }
  
  .r, .r-head {
    display: table-header-group;
    width: 100%;
   
  }
  
  .r .col, .r-head .col {
    float: left;
    width: 16vw;
    border-collapse: collapse;
    border: #EEF1F6 1px solid;
    padding: 8pt;
  }
  
  .custom-actions, .sm-col {
    width: 110pt;
  }
  
  .edit-btn, .del-btn, .test-btn {
    color: white !important;
    padding: 5pt !important;
  }
  
  .edit-btn {
    background-color: #FEAC0E !important;
  }
  
  .del-btn {
    background-color: red !important;
  }
  
  .test-btn {
    background-color: grey !important;
  }
  
  .online {
    background-color: green!important;
  }

  .hidden {
    display: none;
  }
  
  .vuetable-detail-row {
    background-color: #F3F3F5;
  }
  
  .loading-icon {
    color: #20A0FF;
  }
  
  .noShow {
    display:none;
  }
  
</style>



// WEBPACK FOOTER //
// Devices.vue?46655f2d